<div class="tds-container">
    <div class="tds-row tds-gap">
        <!-- Left side -->
        <div class="tds-col-max-4"> 
            <tds-block>
                <div class="tds-row">
                    <div class="tds-col-max-6">
                        <tds-dropdown 
                            name="dropdown" 
                            label="Region" 
                            label-position="outside" 
                            size="sm" 
                            open-direction="auto"/>
                    </div>
                    <div class="tds-col-max-6">
                        <tds-dropdown 
                            name="dropdown" 
                            label="Status" 
                            label-position="outside" 
                            size="sm" 
                            open-direction="auto"/>
                    </div>
                </div>
                <div class="tds-row">
                    <div class="tds-col-max-6">
                        <tds-datetime 
                            size="sm"
                            type="date" 
                            label="Date Started" 
                            min="2023-01-01" 
                        ></tds-datetime> 
                    </div>
                    <div class="tds-col-max-6">
                        <tds-datetime
                            size="sm" 
                            type="date" 
                            label="Date Finished"  
                            min="2023-01-01" 
                        ></tds-datetime>
                    </div>
                </div>
                <div class="tds-row">
                    <div class="tds-col-max-12">
                        <tds-text-field
                            modeVariant="secundary"
                            type="Text" 
                            size="lg" 
                            label="Description" 
                            label-position="no-label" 
                            max-length="300"
                            placeholder="Description"  
                        ></tds-text-field>
                    </div>
                </div>
                <div class="tds-row">
                    <div class="tds-col-max-2">
                        <div modal-actions class="btn-actions">
                            <tds-button size="sm" text="Search"></tds-button>
                            <tds-button size="sm" text="Reset" data-dismiss-modal></tds-button>
                            <tds-button id="open-modal-btn" (click)="show()" size="sm">
                                <tds-icon slot="icon" size="15px" name="plus"></tds-icon> 
                            </tds-button>
                        </div> 
                    </div>
                </div>

                <tds-block mode-variant="primary">
                    <div class="card-container">
                        <div class="card-list">
                            <mat-card class="card" *ngFor="let card of pagedItems">
                                <mat-card-content>
                                <div class="card-body-row">
                                    <div class="card-body">
                                        <div class="card-row two-columns">
                                            <div class="left-info">
                                                <span class="label">Request ID:</span>
                                                <span class="value">{{ card.id }}</span>
                                            </div>
                                            <div class="right-info">
                                                <tds-icon slot="calendar" size="20px" name="calendar" class="icon-spacing-right"></tds-icon> 
                                                <span class="value">{{ card.date }}</span>
                                            </div>
                                            
                                        </div>
                                        <div class="card-row">
                                        <span class="label">Status:</span>
                                        <span class="value">{{ card.status }}</span>
                                        </div>
                                        <div class="card-row">
                                            <span class="value">{{ card.description }}</span>
                                        </div>
                                    </div>
                                    <div class="card-actions">
                                        <button class="icon-button" (click)="show()">
                                            <tds-icon name="chevron_right" size="20px"></tds-icon>
                                        </button>
                                    </div>
                                </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                        
                        <mat-paginator
                            [length]="totalItems"
                            [pageSize]="pageSize"
                            [pageSizeOptions]="[5, 10, 20]"
                            (page)="onPageChange($event)">
                        </mat-paginator>
                    </div>
                </tds-block>
            </tds-block>
        </div>
        
        <!-- Right side -->
        <div class="tds-col-max-7" *ngIf="showDetails">
            <tds-block mode-variant="secundary">
                <div>
                    <div class="tds-row gap-md">
                        <div class="tds-col-max-3">
                            <tds-text-field 
                                type="Text" 
                                size="sm" 
                                label="Id" 
                                label-position="outside"  
                            />
                        </div>
                        <div class="tds-col-max-3">
                            <tds-text-field 
                                type="Text" 
                                size="sm" 
                                label="Chassis Number" 
                                label-position="outside"  
                            />
                        </div>
                        <div class="tds-col-max-2">
                            <tds-dropdown 
                                name="dropdown" 
                                label="Status" 
                                label-position="outside"  
                                size="sm" 
                                open-direction="auto"/>
                        </div>
                        <div class="tds-col-max-2">
                            <tds-dropdown 
                                name="dropdown" 
                                label="Priority" 
                                label-position="outside"  
                                size="sm" 
                                open-direction="auto"/>
                        </div>
                    </div>
                    <div class="tds-row gap-md">
                        <div class="tds-col-max-4">
                            <tds-text-field 
                                type="Text" 
                                size="sm" 
                                label="KD Engenieer" 
                                label-position="outside"  
                            />
                        </div>
                        <div class="tds-col-max-6">
                            <tds-dropdown 
                                name="dropdown" 
                                label="Region" 
                                label-position="outside" 
                                size="sm" 
                                open-direction="auto"/>
                        </div>
                    </div>
                    <div class="tds-row gap-md">
                        <div class="tds-col-max-4">
                            <tds-textarea 
                                rows="5" 
                                label="KD Solution/Comment" 
                                label-position="outside"
                            />
                        </div>
                        <div class="tds-col-max-6">
                            <div class="tds-row">
                                <div class="tds-col-max-12">
                                    <tds-datetime 
                                        size="sm"
                                        type="date" 
                                        label="Closed Date & Time" 
                                        min="2023-01-01" 
                                    />
                                </div>
                            </div>
                            <div class="tds-row">
                                <div class="tds-col-max-12">
                                    <tds-datetime 
                                        size="sm"
                                        type="date" 
                                        label="Closed Date & Time" 
                                        min="2023-01-01" 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tds-row gap-md">
                        <div class="tds-col-max-4">
                            <tds-textarea 
                                rows="5" 
                                label="Background Study" 
                                label-position="outside"
                            />
                        </div>
                        <div class="tds-col-max-6">
                            <span class="textarea-label sc-tds-textarea" style="margin-left: 15px;">KD Solution Accepted?</span>
                            <div class="tds-row">
                                <div class="tds-row">
                                    <div class="tds-col-max-4">
                                        <tds-radio-button name="my-radio-button" value="radio-value"> 
                                            <span slot="label">Yes</span> 
                                        </tds-radio-button>
                                    </div>
                                    <div class="tds-col-max-4">
                                        <tds-radio-button name="my-radio-button" value="radio-value"> 
                                            <span slot="label">No</span> 
                                        </tds-radio-button>
                                    </div>
                                </div>
                            </div>
                            <div class="tds-row">
                                <div class="tds-col-max-12">
                                    <tds-text-field 
                                        type="Text" 
                                        size="sm" 
                                        label="Task Number" 
                                        label-position="outside"  
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tds-row gap-md">
                        <div class="tds-col-max-4">
                            <tds-textarea 
                                rows="5" 
                                label="Proposal STA" 
                                label-position="outside"
                            />
                        </div>
                        <div class="tds-col-max-6">
                            <div class="tds-row">
                                <div class="tds-col-max-12">
                                    <tds-text-field 
                                        type="Text" 
                                        size="sm" 
                                        label="Part Number" 
                                        label-position="outside"  
                                    />
                                </div>
                            </div>
                            <div class="tds-row">
                                <div class="tds-col-max-12">
                                    <tds-dropdown 
                                        name="dropdown" 
                                        label="Classification" 
                                        label-position="outside" 
                                        size="sm" 
                                        open-direction="auto"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tds-row gap-md">
                        <div class="tds-col-max-4">
                            <tds-textarea 
                                rows="5" 
                                label="Notes" 
                                label-position="outside"
                            />
                        </div>
                        <div class="tds-col-max-6">
                            <div class="tds-row">
                                <div class="tds-col-max-12">
                                    <tds-dropdown 
                                        name="dropdown" 
                                        label="Product" 
                                        label-position="outside" 
                                        size="sm" 
                                        open-direction="auto"/>
                                </div>
                            </div>
                            <div class="tds-row">
                                <div class="tds-col-max-12">
                                    <tds-text-field 
                                        type="Text" 
                                        size="sm" 
                                        label="Usermail" 
                                        label-position="outside"  
                                    />
                                </div>
                            </div>
                            <div modal-actions class="modal-actions">
                                <tds-button size="sm" text="Save"></tds-button>
                                <tds-button size="sm" text="Cancel" data-dismiss-modal></tds-button>
                            </div>
                        </div>
                    </div>
                </div>
            </tds-block>
            
        </div>
    </div>

    <app-modal>
        <div modal-body>
            <div class="tds-row">
                <div class="tds-col-max-4">
                    <tds-text-field 
                        type="Text" 
                        size="sm" 
                        label="Id" 
                        label-position="outside"  
                    />
                </div>
                <div class="tds-col-max-4">
                    <tds-text-field 
                        type="Text" 
                        size="sm" 
                        label="Chassis Number" 
                        label-position="outside"  
                    />
                </div>
                <div class="tds-col-max-4">
                    <tds-dropdown 
                        name="dropdown" 
                        label="Priority" 
                        label-position="outside"  
                        size="sm" 
                        open-direction="auto"/>
                </div>
            </div>
            <div class="tds-row">
                <div class="tds-col-max-6">
                    <tds-text-field 
                        type="Text" 
                        size="sm" 
                        label="KD Engenieer" 
                        label-position="outside"  
                    />
                </div>
                <div class="tds-col-max-6">
                    <tds-dropdown 
                        name="dropdown" 
                        label="Region" 
                        label-position="outside" 
                        size="sm" 
                        open-direction="auto"/>
                </div>
            </div>
            <div class="tds-row">
                <div class="tds-col-max-6">
                    <tds-textarea 
                        rows="5" 
                        label="KD Solution/Comment" 
                        label-position="outside"
                    />
                </div>
                <div class="tds-col-max-6">
                    <div class="tds-row">
                        <div class="tds-col-max-12">
                            <tds-datetime 
                                size="sm"
                                type="date" 
                                label="Closed Date & Time" 
                                min="2023-01-01" 
                            />
                        </div>
                    </div>
                    <div class="tds-row">
                        <div class="tds-col-max-12">
                            <tds-datetime 
                                size="sm"
                                type="date" 
                                label="Closed Date & Time" 
                                min="2023-01-01" 
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="tds-row">
                <div class="tds-col-max-6">
                    <tds-textarea 
                        rows="5" 
                        label="Background Study" 
                        label-position="outside"
                    />
                </div>
                <div class="tds-col-max-6">
                    <span class="textarea-label sc-tds-textarea" style="margin-left: 15px;">KD Solution Accepted?</span>
                    <div class="tds-row">
                        <div class="tds-row">
                            <div class="tds-col-max-4">
                                <tds-radio-button name="my-radio-button" value="radio-value"> 
                                    <span slot="label">Yes</span> 
                                </tds-radio-button>
                            </div>
                            <div class="tds-col-max-4">
                                <tds-radio-button name="my-radio-button" value="radio-value"> 
                                    <span slot="label">No</span> 
                                </tds-radio-button>
                            </div>
                        </div>
                    </div>
                    <div class="tds-row">
                        <div class="tds-col-max-12">
                            <tds-text-field 
                                type="Text" 
                                size="sm" 
                                label="Task Number" 
                                label-position="outside"  
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="tds-row">
                <div class="tds-col-max-6">
                    <tds-textarea 
                        rows="5" 
                        label="Proposal STA" 
                        label-position="outside"
                    />
                </div>
                <div class="tds-col-max-6">
                    <div class="tds-row">
                        <div class="tds-col-max-12">
                            <tds-text-field 
                                type="Text" 
                                size="sm" 
                                label="Part Number" 
                                label-position="outside"  
                            />
                        </div>
                    </div>
                    <div class="tds-row">
                        <div class="tds-col-max-12">
                            <tds-dropdown 
                                name="dropdown" 
                                label="Classification" 
                                label-position="outside" 
                                size="sm" 
                                open-direction="auto"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tds-row">
                <div class="tds-col-max-6">
                    <tds-textarea 
                        rows="5" 
                        label="Notes" 
                        label-position="outside"
                    />
                </div>
                <div class="tds-col-max-6">
                    <div class="tds-row">
                        <div class="tds-col-max-12">
                            <tds-dropdown 
                                name="dropdown" 
                                label="Product" 
                                label-position="outside" 
                                size="sm" 
                                open-direction="auto"/>
                        </div>
                    </div>
                    <div class="tds-row">
                        <div class="tds-col-max-12">
                            <tds-text-field 
                                type="Text" 
                                size="sm" 
                                label="Usermail" 
                                label-position="outside"  
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div modal-actions class="modal-actions">
            <tds-button size="sm" text="Save"></tds-button>
            <tds-button size="sm" text="Cancel" data-dismiss-modal></tds-button>
        </div>
    </app-modal>
</div>